module.exports = require("webpack");


//////////////////
// WEBPACK FOOTER
// external "webpack"
// module id = 9
// module chunks = 0